import { createRouter, createWebHistory } from 'vue-router'
//import RenwuView from '../views/saleafter/RenwuView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongInfoView.vue')
  },
  
  
  {
    path: '/rengongInfo',
    name: 'rengongInfo',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongInfoView.vue')
  },
  {
    path: '/rengongWlq',
    name: 'rengongWlq',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongWlqView.vue')
  },
  {
    path: '/RengongYlqRw',
    name: 'RengongYlqRw',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongYlqRwView.vue')
  },
  {
    path: '/RengongYlqRwNew',
    name: 'RengongYlqRwNew',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongYlqRwNewView.vue')
  },
  {
    path: '/RengongFeigeMessage',
    name: 'RengongFeigeMessage',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongFeigeMessage.vue')
  },
  {
    path: '/RengongFeigeMessageList',
    name: 'RengongFeigeMessageList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongFeigeMessageList.vue')
  },
  {
    path: '/RengongFeigeSendList',
    name: 'RengongFeigeSendList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongFeigeSendListView.vue')
  },
  {
    path: '/RengongFeigeMessageupdate',
    name: 'RengongFeigeMessageupdate',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongFeigeMessageupdate.vue')
  },
  {
    path: '/RengongCPKPI',
    name: 'RengongCPKPI',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongCPKPIView.vue')
  },
  {
    path: '/RengongKFKPI',
    name: 'RengongKFKPI',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongKFKPIView.vue')
  },
  {
    path: '/RengongGRKPI',
    name: 'RengongGRKPI',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongGrKPIView.vue')
  },
  {
    path: '/RengongDSH',
    name: 'RengongDSH',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongDSHView.vue')
  },
  {
    path: '/RengongCXTool',
    name: 'RengongCXTool',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongCXToolView.vue')
  },
  {
    path: '/Rengongbailing',
    name: 'Rengongbailing',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/rengongcuiping/RengongbailingView.vue')
  },
  
  {
    path: '/SmsCreate',
    name: 'SmsCreate',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/sms/SmsCreateView.vue')
  },
  {
    path: '/Smslist',
    name: 'Smslist',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/sms/SmslistView.vue')
  },
  {
    path: '/SmsDonelist',
    name: 'SmsDonelist',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/sms/SmsDonelistView.vue')
  },
  {
    path: '/SmsFeeChange',
    name: 'SmsFeeChange',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/smsfee/SmsFeeChangeView.vue')
  },
  {
    path: '/SmsFeeShareShop',
    name: 'SmsFeeShareShop',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/smsfee/SmsFeeShareShopView.vue')
  },
  
  
  /*
  {
    path: '/dashboard',
    name: 'dashboard',
    children:[{
      path: '/dashboard/analysis',
      name: 'analysis',
      component:AnalySis
    },
    {
      path: '/dashboard/monitor',
      name: 'monitor',
      component:MoniTor
    }]
  }*/
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
